(function () {

    'use strict';

    angular.module('iplusjs.api.cache', [
        'lodash',
        'iplusjs.utils.misc'
    ])
    .service('ApiCacheService', ApiCacheService);

    ApiCacheService.$inject = [
        '$log',
        '$cacheFactory',
        'lodash',
        'MiscUtilsService'
    ];
    function ApiCacheService($log, $cacheFactory, _, MiscUtilsService) {
        var that = this,
            apiCache = $cacheFactory('apiCache');

        that.put = put;
        that.get = get;
        that.remove = remove;
        that.clear = clear;
        that.isCached = isCached;
        function put(id, value) {
            if (!isCached(value)) {
                apiCache.put(id, value);
            }
        }
        function get(id) {
            if (isCached(id)) {
                return apiCache.get(id);
            }

            return null;
        }
        function remove(id) {
            apiCache.remove(id);
        }
        function clear() {
            apiCache.removeAll();
        }
        function isCached(id) {
            return MiscUtilsService.isNotEmpty(apiCache.get(id));
        }
    }

})();
